function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9 10C9 9.44772 9.44772 9 10 9L22 9C22.5523 9 23 9.44772 23 10C23 10.5523 22.5523 11 22 11L10 11C9.44772 11 9 10.5523 9 10ZM9 16C9 15.4477 9.44772 15 10 15L22 15C22.5523 15 23 15.4477 23 16C23 16.5523 22.5523 17 22 17L10 17C9.44772 17 9 16.5523 9 16ZM10 21C9.44772 21 9 21.4477 9 22C9 22.5523 9.44772 23 10 23L22 23C22.5523 23 23 22.5523 23 22C23 21.4477 22.5523 21 22 21L10 21Z"
});

function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.a855c862f37fd50a47b9883bbf1ba5f2.svg";
export { ForwardRef as ReactComponent };